<div class="container">
  <div class="toolbar">
    <div class="welcome logo-img">
      <img src="assets/logo.svg" height="61" width="91">
    </div>
  </div>

  <div class="toolbar profile" (click)="toggleMenu()">
    <app-avatar class="avatar-img" [src]="(user$ | async)?.avatarUrl" [alt]="(user$ | async)?.name || 'Perfil'"
      [size]="46" [iconSize]="30"></app-avatar>
    <div class="welcome">
      <small class="small">Seja bem vindo(a)!</small>
      <p>{{ (user$ | async)?.name ?? 'Nome do Usuário' }}</p>
    </div>

    <div class="profile">
      <button class="icon" aria-label="Perfil" aria-haspopup="menu" aria-expanded="false">
        <iconify-icon icon="mdi:chevron-down" class="down" width="24" height="24"></iconify-icon>
      </button>

      <div class="menu" [class.is-open]="isMenuOpen" role="menu">
        <button role="menuitem" class="menu-item" (click)="onLogout()">
          <iconify-icon icon="mdi:logout" width="18" height="18"></iconify-icon>
          <span>Sair</span>
        </button>
      </div>
    </div>
  </div>

</div>
